/* After the 21+ age gate (AVP) is answered, put keyboard focus on the Alia
   popup if it is showing, as Alia does itself when it opens. When Alia opens
   behind the unanswered gate, rebrand.css hides it and Alia's own focus call
   is lost, so after I'M OVER 21 focus would stay on the page and the next Tab
   could land on another app's hidden control (Rebuy's closed cart drawer).
   Acts only while focus is on the page or still in the gate, so it never
   takes focus from somewhere the visitor chose. */
(function () {
  'use strict';
  if (window.WillieAgeGateAliaFocus) return;
  window.WillieAgeGateAliaFocus = true;

  function focusAlia() {
    var gate = document.querySelector('.gminfoTechmodal');
    if (gate && getComputedStyle(gate).display !== 'none') return;
    var alia = document.querySelector('[id^="alia-root"]');
    if (!alia || getComputedStyle(alia).display === 'none') return;
    var active = document.activeElement;
    if (active && active !== document.body && !active.closest('.gminfoTechmodal')) return;
    var target = alia.getAttribute('role') === 'dialog'
      ? alia
      : alia.querySelector('[role="dialog"], button, [href], [tabindex]:not([tabindex="-1"])');
    if (target) target.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (event) {
    var el = event.target;
    if (!el || !el.closest || !el.closest('.gm_age_agree_btn')) return;
    // AVP hides the gate in its own click handler: try after it, and again in
    // case the popup is still appearing.
    [100, 500, 1500].forEach(function (delay) {
      setTimeout(focusAlia, delay);
    });
  }, true);
})();
